<template>
  <div class="account-setting">
    <second-menu-link-content>
      <template v-slot:header>
        <span>账号设置</span>
      </template>
      <template v-slot:content>
        <div class="main">
          <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
            <el-form-item label="公司名称：">
              <el-input
                :class="staff?'disabled':'gray'"
                :disabled="staff"
                v-model="formLabelAlign.company"
              ></el-input>
            </el-form-item>
            <el-form-item label="登录账号：">
              <el-input v-model="formLabelAlign.username" disabled class="disabled"></el-input>
              <el-button class="btn-text" type="text" @click="changePW">修改密码</el-button>
            </el-form-item>
            <el-form-item label="手机号：">
              <el-input v-model="formLabelAlign.phone" disabled class="disabled"></el-input>
              <el-button class="btn-text" type="text" @click="changePhone">更改手机</el-button>
            </el-form-item>
            <el-form-item label="负责人：" v-if="!staff">
              <el-input class="gray" v-model="formLabelAlign.person"></el-input>
            </el-form-item>
            <el-form-item label="所在区域：" v-if="!staff">
              <el-cascader
                v-model="formLabelAlign.area"
                :options="address"
                :props="defaultParams"
                class="gray"
                placeholder="所在区域"
                filterable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址：" v-if="!staff">
              <el-input class="gray" v-model="formLabelAlign.address"></el-input>
            </el-form-item>
            <el-form-item label="姓名：" v-if="staff">
              <el-input class="gray" v-model="formLabelAlign.name"></el-input>
            </el-form-item>
            <el-form-item label="部门：" v-if="staff">
              <el-input disabled class="disabled" v-model="formLabelAlign.department"></el-input>
            </el-form-item>
            <el-form-item label="职位：" v-if="staff">
              <el-input disabled class="disabled" v-model="formLabelAlign.position"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" v-if="staff">
              <el-input class="gray" v-model="formLabelAlign.email"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-blue" type="primary" @click="submitForm(formLabelAlign)">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import { saveDBUserRealName } from "common/js/storage";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBUser from "models/db/user.js";
import DBAddress from "models/db/address.js";
const dbUser = new DBUser();
const dbAddress = new DBAddress();
export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        id: "",
        company: "", // 公司名
        username: "", // 登录账号
        name: "", // 姓名
        department: "", // 部门
        position: "", // 职位
        email: "", // 邮箱
        phone: "", // 手机
        person: "", // 负责人
        area: [],
        address: ""
      },
      address: [] /* 地址列表 */,
      staff: "", // 是否是员工
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      } // 联级格式
    };
  },
  components: {
    SecondMenuLinkContent
  },
  created() {
    this.getAddress();
    this.getInformation();
  },
  methods: {
    // 获取当前信息
    getInformation() {
      dbUser.getDBInformation().then(res => {
        if (res.success) {
          if (res.result.adminFlag === 2) {
            this.staff = true;
            this.formLabelAlign.id = res.result.id;
            this.formLabelAlign.company = res.result.companyName;
            this.formLabelAlign.username = res.result.username;
            this.formLabelAlign.phone = res.result.telephone;
            this.formLabelAlign.name = res.result.contact;
            this.formLabelAlign.department = res.result.name;
            this.formLabelAlign.position = res.result.position;
            this.formLabelAlign.email = res.result.email;
          } else {
            this.staff = false;
            this.formLabelAlign.id = res.result.id;
            this.formLabelAlign.company = res.result.companyName;
            this.formLabelAlign.username = res.result.username;
            this.formLabelAlign.phone = res.result.telephone;
            this.formLabelAlign.person = res.result.head;
            this.formLabelAlign.area = [res.result.province];
            this.formLabelAlign.address = res.result.address;
            if (res.result.city) {
              this.formLabelAlign.area.push(res.result.city);
              if (res.result.regions) {
                this.formLabelAlign.area.push(res.result.regions);
              }
            }
          }
        }
      });
    },
    // 获取三级地址
    getAddress() {
      dbAddress.getDBAddressMock().then(res => {
        this.address = res;
      });
      // dbAddress.getDBAddress().then(res => {
      //   if (res.success) {
      //     for (let i = 0; i < res.result.length; i++) {
      //       if (res.result[i].children.length < 1) {
      //         res.result[i].children = null;
      //       } else {
      //         for (let j = 0; j < res.result[i].children.length; j++) {
      //           if (res.result[i].children[j].children.length === 1) {
      //             res.result[i].children[j].children = null;
      //           }
      //         }
      //       }
      //     }
      //     this.address = res.result;
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    // 提交表单
    submitForm() {
      if (this.staff) {
        let contact = this.formLabelAlign.name;
        let email = this.formLabelAlign.email;
        let data = {
          contact,
          email
        };
        dbUser.postDBModify(data).then(res => {
          if (res.success) {
            this.$message.success("修改成功");
            saveDBUserRealName(contact);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        let username = this.formLabelAlign.username;
        let companyName = this.formLabelAlign.company;
        let head = this.formLabelAlign.person;
        let province = this.formLabelAlign.area[0];
        let city = this.formLabelAlign.area[1]
          ? this.formLabelAlign.area[1]
          : null;
        let regions = this.formLabelAlign.area[2]
          ? this.formLabelAlign.area[2]
          : null;
        let address = this.formLabelAlign.address;
        let data = {
          username,
          companyName,
          head,
          province,
          city,
          regions,
          address
        };
        dbUser.postDBModify(data).then(res => {
          if (res.success) {
            this.$message.success("修改成功");
            saveDBUserRealName(head);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 修改密码
    changePW() {
      this.$router.push({
        path: "change-password",
        query: { username: this.formLabelAlign.username }
      });
    },
    // 修改手机
    changePhone() {
      this.$router.push({
        path: "change-phone",
        query: { telephone: this.formLabelAlign.phone }
      });
    }
  }
};
</script>

<style lang="scss">
.account-setting {
  width: 100%;
  height: 100%;
  .main {
    .el-form {
      padding: 20px 0 0 37px;
      letter-spacing: 1px;
      .el-form-item {
        margin-bottom: 20px;
        .el-form-item__content {
          width: 300px;
          position: relative;
          .btn-text {
            position: absolute;
            right: -60px;
            top: 0px;
            font-size: 14px;
            letter-spacing: 0;
          }
          .btn-blue {
            width: 96px;
            letter-spacing: 4px;
          }
          .el-cascader {
            width: 300px;
          }
        }
      }
    }
  }
}
</style>
